module.exports = __webpack_public_path__ + "img/authe-5.b994b84.jpg";